<template>
  <div role="tablist" class="tabs tabs-lifted">
    <template v-for="(tab, index) in tabs" :key="index">
      <input 
        type="radio" 
        :name="groupName" 
        role="tab" 
        class="tab tab-label-wrapper [--tab-bg:#eeeeef] [--tab-border-color:#cfcfd1] dark:[--tab-bg:oklch(27.4%_0.006_286.033)] dark:[--tab-border-color:#4d4c4f]" 
        :aria-label="tab.ariaLabel || tab.label || tab.labelDesktop"
        :checked="index === activeTab"
        @change="$emit('update:activeTab', index)"
        :data-label-mobile="tab.labelMobile || tab.label"
        :data-label-desktop="tab.labelDesktop || tab.label"
      />
      <div role="tabpanel" class="tab-content bg-base-200 !border-theme rounded-box p-6">
        <slot :name="`tab-${index}`" :tab="tab" />
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
    validator: (tabs) => tabs.every(tab => tab.label || (tab.labelMobile && tab.labelDesktop))
  },
  activeTab: {
    type: Number,
    default: 0
  }
})

defineEmits(['update:activeTab'])

// Generate unique group name for radio buttons
const groupName = computed(() => `tabs-group-${Math.random().toString(36).substr(2, 9)}`)
</script>

<style scoped>
.tab {
  white-space: nowrap;
}

/* Show mobile label on small screens */
@media (max-width: 639px) {
  .tab-label-wrapper::after {
    content: attr(data-label-mobile);
  }
}

/* Show desktop label on larger screens */
@media (min-width: 640px) {
  .tab-label-wrapper::after {
    content: attr(data-label-desktop);
  }
}
</style>